export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14365.d1f12545.jpg";